/**
 * @author pjh
 * @date 2025.09.02
 * @description 폰트 관련 유틸리티 함수
 */

import { CssFontCreate, CssFontDetail } from "../type/cssTemplate";

/**
 * 폰트 URL을 S3 URL로 변환
 */
export const convertToS3Url = (url: string): string => {
    if (url && url.includes('file.sajutalktalk.com')) {
        return url.replace(
            'https://file.sajutalktalk.com',
            'https://saju-directory.s3.ap-northeast-2.amazonaws.com'
        );
    }
    return url;
};

/**
 * 파일 확장자에 따른 폰트 포맷 결정
 */
export const getFontFormat = (fontUrl: string): string => {
    const extension = fontUrl.split('.').pop()?.toLowerCase();
    switch(extension) {
        case 'woff2':
            return 'woff2';
        case 'woff':
            return 'woff';
        case 'ttf':
            return 'truetype';
        case 'otf':
            return 'opentype';
        case 'eot':
            return 'embedded-opentype';
        default:
            return 'opentype';
    }
};

/**
 * CssFontCreate를 CssFontDetail로 변환
 */
export const convertCreateFontToDetail = (createFont: CssFontCreate): CssFontDetail => {
    return {
        id: createFont.id || '',
        localKey: createFont.localKey,
        cssName: createFont.cssName,
        categoryName: createFont.categoryName,
        remark: createFont.remark,
        file: {
            id: createFont.file.id,
            originalFileName: createFont.file.fileName,
            fileFullUrl: createFont.file.fileFullUrl,
            fileUrl: createFont.file.fileUrl,
            fileSize: createFont.file.fileSize,
            fullUrl: createFont.file.fileFullUrl || '',
            use: true
        },
        originFile: createFont.originFile || [],
        currentUseFont: createFont.file.fileName,
        useFontUrl: createFont.file.fileFullUrl || ''
    };
};

/**
 * @font-face CSS 규칙 생성
 */
export const createFontFaceRule = (fontUrl: string, fontName: string): string => {
    const format = getFontFormat(fontUrl);
    return `
        @font-face {
            font-family: '${fontName}';
            src: url('${fontUrl}') format('${format}');
            font-display: swap;
            font-weight: normal;
            font-style: normal;
        }
    `;
};

/**
 * 요소에 폰트 스타일 적용
 */
export const applyFontToElement = (element: HTMLElement, fontName: string): void => {
    if (!element) return;
    
    element.style.setProperty('font-family', `'${fontName}', sans-serif`, 'important');
    element.style.setProperty('line-height', '1', 'important');
    
    // 모든 자식 요소에도 폰트 적용
    const children = element.querySelectorAll('*');
    children.forEach(child => {
        (child as HTMLElement).style.setProperty('font-family', `'${fontName}', sans-serif`, 'important');
    });
};